// extracted by mini-css-extract-plugin
export var active = "BuieDemo-module--active--0e696";
export var buieDemo = "BuieDemo-module--buieDemo--4ee58";
export var column = "BuieDemo-module--column--359a7";
export var iframe = "BuieDemo-module--iframe--fde98";
export var mobilePill = "BuieDemo-module--mobilePill--7969c";
export var mobilePillWrapper = "BuieDemo-module--mobilePillWrapper--cefe6";
export var tileWrapper = "BuieDemo-module--tileWrapper--36e4c";